<span class="mx-1">
	<!-- class="gray-700" -->
	<fa-icon [icon]="infoIcon" [popover]="popoverTemplate" triggers="mouseenter:mouseleave" container="body"></fa-icon>
</span>
